import React from 'react';
import { CMultiSelect } from '@coreui/react-pro';

export type MultiSelectOption = {
    text: string;
    value: string;
    disabled?: boolean;
    selected?: boolean;
};

interface IMultiSelectClearDropdown {
    defaultOptions: MultiSelectOption[];
    values: MultiSelectOption[];
    zIndex: number;
    isDisabled?: boolean;
    onChangeField?: (
        value: MultiSelectOption[],
        field: string,
        state: any,
        setState: (next: any) => void,
    ) => void;
    field?: string;
    state?: any;
    onChange?: (next: any) => void;
    placeholder?: string;
    selectAll?: boolean;
    resetKey?: number | string;
}

const MultiSelectClearDropdown: React.FC<IMultiSelectClearDropdown> = ({
    defaultOptions,
    values = [],
    zIndex,
    isDisabled = false,
    onChangeField,
    field = '',
    state,
    onChange,
    placeholder,
    selectAll,
    resetKey,
}) => {
    const selectedSet = new Set((values || []).map((v) => v.value));
    const displayOptions = defaultOptions.map((o) => ({
        ...o,
        selected: selectedSet.has(o.value),
        disabled: false,
    }));

    const onChangeValue = (itemList: MultiSelectOption[]) => {
        if (onChangeField) {
            onChangeField(itemList, field, state, onChange || (() => { }));
        }
    };

    return (
        <div
            className={isDisabled ? 'multi-select-disabled' : 'multi-select'}
            style={isDisabled ? { pointerEvents: 'none' } : {}}
        >
            <CMultiSelect
                key={resetKey}
                placeholder={placeholder}
                style={{ zIndex: zIndex || 1039 }}
                options={displayOptions as any}
                onChange={(items: any) => {
                    onChangeValue(items);
                }}
                selectionType="text"
                selectAll={selectAll}
                cleaner={false}
            />
        </div>
    );
};

export default MultiSelectClearDropdown;
